import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** При каждом SPA-переходе прокручивает окно вверх. */
export default function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, search]);

  return null;
}
